require('./zingchart.min.js');
zingchart.MODULESDIR = './modules/';
module.exports = zingchart;



//////////////////
// WEBPACK FOOTER
// ./~/zingchart/index.js
// module id = 1278
// module chunks = 0